// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3DstB","footer":"ModalError_footer__yTbKJ"};